
import { useEffect } from 'react';
import { useFetchTracks } from './featuredTracks/useFetchTracks';
import { useTrackOperations } from './featuredTracks/useTrackOperations';
import { FeaturedTrack } from '@/types/featuredTracks';

export type { FeaturedTrack };

export function useFeaturedTracks() {
  const { 
    tracks, 
    isLoading, 
    error, 
    fetchFeaturedTracks, 
    fetchTracksByUserId,
    setTracks
  } = useFetchTracks();
  
  const { 
    addFeaturedTrack, 
    deleteTrack, 
    reorderTracks: reorderTracksOperation 
  } = useTrackOperations(fetchFeaturedTracks);

  useEffect(() => {
    fetchFeaturedTracks();
  }, [fetchFeaturedTracks]);

  const reorderTracks = async (updatedTracks: FeaturedTrack[]) => {
    setTracks(updatedTracks);
    await reorderTracksOperation(updatedTracks);
  };

  return { 
    tracks, 
    isLoading, 
    error, 
    refreshTracks: fetchFeaturedTracks,
    fetchTracksByUserId,
    addFeaturedTrack,
    deleteTrack,
    reorderTracks
  };
}
